// ==============================
// B2STOCK MST PATCH
// The app block only outputs 4 of the required istock properties.
// undefined != '' evaluates true, causing querySelectorAll(undefined) to throw
// and B2stock to silently fail on every product page.
// ==============================
window.istock = window.istock || {};
if (typeof window.istock.variant_selector === 'undefined') window.istock.variant_selector = '';
if (typeof window.istock.option_selector === 'undefined') window.istock.option_selector = '';
if (typeof window.istock.shop === 'undefined') window.istock.shop = 'simply-carbon-fiber.myshopify.com';
if (typeof window.istock.is_product_page === 'undefined') window.istock.is_product_page = window.location.pathname.indexOf('/products/') !== -1;
if (typeof window.istock.allow_preorder === 'undefined') window.istock.allow_preorder = false;
if (typeof window.istock.allow_resubscribe === 'undefined') window.istock.allow_resubscribe = false;
if (typeof window.istock.onchange_delay === 'undefined') window.istock.onchange_delay = 300;
if (typeof window.istock.init_delay === 'undefined') window.istock.init_delay = 300;
if (typeof window.istock.logs === 'undefined') window.istock.logs = false;

// ==============================
// B2STOCK FALLBACK VISIBILITY
// B2stock's own init calls istock_init.php async — if that returns empty it bails
// before ever showing the wrapper. We bypass it entirely:
//   1. On page load: 700ms after window.load (plenty of time for B2stock's API call),
//      if the ATC button is disabled (= current variant unavailable) and the wrapper is
//      still hidden, force it visible.
//   2. On variant:change: directly toggle based on variant.available from the event.
// ==============================
function b2stockShow(wrapper) {
  // Restore title text — B2stock clears innerHTML when it hides the widget
  var titleEl = wrapper.querySelector('.iStock-title');
  if (titleEl && !titleEl.textContent.trim()) {
    titleEl.textContent = (window.istock && window.istock.title) || 'Out Of Stock!';
  }
  wrapper.style.display = 'block';
}

function b2stockSync() {
  var wrapper = document.querySelector('.iStock-wrapper');
  if (!wrapper) return;
  var atcBtn = document.querySelector('[data-add-to-cart]');
  if (atcBtn && atcBtn.disabled) {
    b2stockShow(wrapper);
  }
}
window.addEventListener('load', function() {
  setTimeout(b2stockSync, 700);
});

document.addEventListener('variant:change', function(e) {
  var wrapper = document.querySelector('.iStock-wrapper');
  if (!wrapper) return;
  var variant = e.detail && e.detail.variant;
  if (!variant) return;
  if (variant.available === false) {
    b2stockShow(wrapper);
  } else {
    wrapper.style.display = 'none';
  }
});

// ==============================
// CART STATE & CORE LOGIC
// ==============================
let globalCart = null;
let isSyncingCart = false;
let fetchPatched = false;
let isInternalCartUpdate = false;
let checkoutInProgress = false;
let cartCleanupPromise = null;
const pendingCartWrites = new Set();

document.addEventListener('cart:updated', async (event) => {
  if (checkoutInProgress || isInternalCartUpdate || !window.si_product) return;

  const cart = event.detail.cart || {};
  const items = cart.items || [];
  const siId = String(window.si_product);
  const siItem = items.find(it => String(it.id) === siId);

  if (siItem && items.length === 1) {
    isInternalCartUpdate = true;
    try {
      await removeFromCart(siId);
    } finally {
      isInternalCartUpdate = false;
    }
    return;
  }

  if (siItem && siItem.quantity > 1) {
    isInternalCartUpdate = true;
    try {
      await setLineItemQuantity(siId, 1);
    } finally {
      isInternalCartUpdate = false;
    }
    return;
  }
});

async function addToCart(variantId) {
  if (!variantId) throw new Error('addToCart: missing variantId');
  const siId = String(variantId);
  await refreshCart();

  const existing = (globalCart?.items || []).find(it => String(it.id) === siId);
  if (existing) {
    if (existing.quantity > 1) {
      await setLineItemQuantity(siId, 1);
    } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:updated', {
        detail: { product: { id: variantId, alreadyPresent: true } }
      }));
    }
    return existing;
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: 'cart-ajax-section' })
  });
  if (!res.ok) throw new Error('Could not add to cart.');
  const data = await res.json();
  lastCartMarkup = (data.sections && data.sections['cart-ajax-section']) || '';   // SCF 2026-09-22: drawer HTML rides along
  await refreshCart();
  return data;
}

async function removeFromCart(variantId) {
  if (!variantId) throw new Error('removeFromCart: missing variantId');
  const updates = { [String(variantId)]: 0 };
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ updates, sections: 'cart-ajax-section' })
  });
  if (!res.ok) throw new Error('Could not remove from cart.');
  const cart = await res.json();
  document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));   // cart.sections carries the drawer markup
  await refreshCart();
  return cart;
}

async function setLineItemQuantity(variantIdStr, qty) {
  const updates = { [variantIdStr]: qty };
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ updates, sections: 'cart-ajax-section' })
  });
  if (!res.ok) throw new Error('Failed to set quantity');
  const cart = await res.json();
  document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart } }));   // cart.sections carries the drawer markup
  await refreshCart();
  return cart;
}

// ==============================
// CART MONITORING HELPERS
// ==============================
function initGlobalCart() {
  monitorShopifyCartUpdates();
  refreshCart();
}

function monitorShopifyCartUpdates() {
  if (fetchPatched) return;
  fetchPatched = true;

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const [url] = args;
    const isMutation = isCartMutationRequest(url);
    const checkoutRequest = checkoutInProgress;
    const request = originalFetch.apply(this, args).then(async (response) => {
      // Checkout reads its own fresh response and navigates; no redraw or follow-up GET.
      if (isMutation && response.ok && !checkoutRequest) {
        try {
          const data = await response.clone().json();
          const cart = window.theme && theme.cart && theme.cart.stateFrom(data);
          if (cart) acceptCart(cart);
          else refreshCart(); // Compatibility fallback; never hold the mutation response.
        } catch (_) { refreshCart(); }
      }
      return response;
    });
    if (isMutation && !checkoutRequest) {
      pendingCartWrites.add(request);
      const settled = () => pendingCartWrites.delete(request);
      request.then(settled, settled);
    }
    return request;
  };
}

function isCartMutationRequest(url) {
  return typeof url === 'string' && /\/cart\/(add|change|update|clear|remove)(\.js)?(\?|$)/.test(url);
}

let cartSyncPromise = null;
let cartStateRevision = 0;
function acceptCart(cart) {
  globalCart = cart;
  cartStateRevision++;
  if (!isInternalCartUpdate) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
}
let lastCartMarkup = '';   // SCF 2026-09-22: drawer markup returned by the last add request (Section Rendering API)
function buildDetail() { const d = { cart: globalCart }; if (lastCartMarkup) { d.markup = lastCartMarkup; lastCartMarkup = ''; } return d; }

async function refreshCart() {
  // Return the in-flight request so concurrent callers await the SAME sync
  // instead of resolving early with a stale globalCart
  if (cartSyncPromise) return cartSyncPromise;
  const revision = cartStateRevision;
  cartSyncPromise = (async () => {
    try {
      const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('failed to fetch cart');
      const cart = await res.json();
      // A slow page-load GET must not overwrite a newer mutation response.
      if (revision === cartStateRevision) acceptCart(cart);
    } catch (err) {
      console.error('failed to fetch cart:', err);
    } finally {
      cartSyncPromise = null;
    }
  })();
  return cartSyncPromise;
}

async function cleanCart() {
  if (checkoutInProgress) return;
  if (cartCleanupPromise) return cartCleanupPromise;
  cartCleanupPromise = (async () => {
    try {
      if (!globalCart) await refreshCart();
      if (globalCart?.items?.length) {

        const updates = {};
        globalCart.items.forEach(item => {
          const isFastProcessing = String(item.id) === String(window.si_product);
          // Only lines the gift system itself added carry _free_gift — never remove
          // other $0 lines (100%-off discount codes, GWP apps, $0 SKUs)
          const isFreeGift = item.properties && item.properties._free_gift === 'true';
          if (isFastProcessing || isFreeGift) updates[item.key] = 0;
        });
        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates })
          });
          await refreshCart();
          document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: globalCart } }));
        }
      }
    } catch (err) {
      console.error('Failed to clean cart on load:', err);
    }
  })();
  try { await cartCleanupPromise; }
  finally { cartCleanupPromise = null; }
}

// ==============================
// EVENT HANDLERS
// ==============================
document.addEventListener("drawerOpen", async () => {
  try { await cleanCart(); } catch (e) { console.error(e); }
});
document.addEventListener("cart:updated", cleanCart, { once: true });

window.addEventListener('pageshow', (e) => {
  // bfcache restores (Back from checkout) skip DOMContentLoaded entirely — re-sync and re-clean
  if (e.persisted) refreshCart().then(() => cleanCart());
});

document.addEventListener("DOMContentLoaded", () => {
  monitorShopifyCartUpdates();
  // Await the first cart sync BEFORE cleaning — calling cleanCart with an
  // unpopulated globalCart made the page-load cleanup a silent no-op
  refreshCart().then(() => cleanCart());

  const form = document.querySelector('form#CartDrawerForm');
  if (form) {
    const checkoutButton = form.querySelector('[name="checkout"]');
    const withoutPriority = form.querySelector('.fastprocessing');
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const controls = [checkoutButton, withoutPriority].filter(Boolean);
    const disabledBefore = new Map();

    function checkoutBusy(busy) {
      checkoutInProgress = busy;
      if (busy) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
      controls.forEach(control => {
        if (busy) {
          disabledBefore.set(control, control.disabled);
          if ('disabled' in control) control.disabled = true;
          control.setAttribute('aria-disabled', 'true');
        } else {
          if ('disabled' in control && disabledBefore.has(control)) control.disabled = disabledBefore.get(control);
          control.removeAttribute('aria-disabled');
          control.classList.remove('btn--loading');
        }
      });
      if (busy && checkoutButton) checkoutButton.classList.add('btn--loading');
    }

    function checkoutExtras(cart) {
      const updates = {};
      (cart && cart.items || []).forEach(item => {
        if ((window.si_product && String(item.id) === String(window.si_product)) ||
            (item.properties && item.properties._free_gift === 'true')) updates[item.key] = 0;
      });
      return updates;
    }

    async function prepareCheckout(updates) {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates, sections: 'cart-ajax-section' })
      });
      if (!response.ok) throw new Error('Could not prepare checkout.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid checkout response.');
      acceptCart(cart);
      return cart;
    }

    async function checkout(withPriority) {
      if (checkoutInProgress) return;
      checkoutBusy(true);
      const oldError = form.querySelector('[data-scf-checkout-error]');
      if (oldError) oldError.remove();
      let checkoutPrepared = false;
      try {
        // Finish already-started cart writes/cleanup before preparing this checkout.
        await Promise.allSettled([...pendingCartWrites, cartCleanupPromise, cartSyncPromise].filter(Boolean));
        let updates = checkoutExtras(globalCart);
        let cart = await prepareCheckout(updates);
        // Another tab or a previous checkout may have added lines absent from our cache.
        updates = checkoutExtras(cart);
        if (Object.keys(updates).length) {
          cart = await prepareCheckout(updates);
        }
        if (Object.keys(checkoutExtras(cart)).length) throw new Error('Checkout extras were not removed.');
        checkoutPrepared = true;

        let markup = cart.sections && cart.sections['cart-ajax-section'];
        if (!markup) {
          // Shopify can return null for a section even when the cart update succeeds.
          try {
            const response = await fetch(root + 'cart?view=ajax');
            if (response.ok) markup = await response.text();
          } catch (err) { console.error('Gift display unavailable:', err); }
        }
        const items = [];
        const ids = new Set();
        // SCF 2026-10-26 ("go gift card"): when nothing ships (gift cards only), add neither the fee nor a physical free gift.
        const ships = cart.items.some(item => item.requires_shipping);
        if (withPriority && window.si_product && ships) {
          items.push({ id: Number(window.si_product), quantity: 1 });
          ids.add(Number(window.si_product));
        }
        // Use server-qualified gifts BEFORE the priority fee is added, not stale drawer DOM.
        const fresh = document.createElement('div');
        fresh.innerHTML = markup || '';
        if (ships) fresh.querySelectorAll('.free-gift-box.is-done > input[name="freegifts"]').forEach(input => {
          const id = Number(input.value);
          if (Number.isSafeInteger(id) && id > 0 && !ids.has(id)) {
            ids.add(id);
            items.push({ id, quantity: 1, properties: { _free_gift: 'true' } });
          }
        });
        if (items.length && cart.items.length) {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Optional checkout items could not be added.');
        }
      } catch (err) {
        console.error('Checkout preparation:', err);
        // If the cart update failed, an uncached old fee may still exist. Allow retry
        // instead of sending the shopper through with a checkout choice we couldn't apply.
        if (!checkoutPrepared) {
          const error = document.createElement('div');
          error.className = 'errors';
          error.dataset.scfCheckoutError = '';
          error.setAttribute('role', 'alert');
          error.textContent = 'We could not update your checkout choice. Please try again.';
          (form.querySelector('.cart__checkout-wrapper') || checkoutButton || form).before(error);
          checkoutBusy(false);
          return;
        }
      }
      // Never retry an uncertain optional add or let a failed freebie block the purchase.
      window.location.href = root + 'checkout';
    }

    form.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      checkout(!!withoutPriority);
    });
    if (withoutPriority) withoutPriority.addEventListener('click', event => {
      event.preventDefault();
      checkout(false);
    });
    // While leaving for checkout, further cart clicks cannot start competing mutations.
    form.addEventListener('click', event => {
      if (checkoutInProgress) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    window.addEventListener('pageshow', event => {
      if (event.persisted) checkoutBusy(false);
    });
  }

  document.addEventListener('click', async (e) => {
    // Check if the clicked element matches the selector
    const button = e.target.closest('.btn.rec-add:not(.rec-vs-open)');
    if (!button) return; // ignore clicks elsewhere

    const variantId = button.dataset.id;
    if (!variantId) return;

    // Add loading state
    button.classList.add('btn--loading');

    try {
      // Await your async function
      await addToCart(variantId);
      document.dispatchEvent(new CustomEvent('cart:build', { detail: buildDetail() }));
    } catch (error) {
      console.error('Failed to add to cart:', error);
    } finally {
      // Always remove loading class, even on error
      button.classList.remove('btn--loading');
    }
  });



  // ==============================
  // CART-AWARE VARIANT MATCHING
  // Items already in the cart (e.g. a case with Device: iPhone 17 Pro Max)
  // pin the matching variant of an upsell, so "+ ADD" can skip the dropdown.
  // Matching is by option VALUE (normalized), so "Device" on the case still
  // pins "Phone Model" on a protector as long as the values are spelled alike.
  // ==============================
  function cartOptionValueSet() {
    const values = new Set();
    const items = (globalCart && globalCart.items) || [];
    items.forEach((item) => {
      (item.options_with_values || []).forEach((opt) => {
        if (opt && opt.value) values.add(String(opt.value).trim().toLowerCase());
      });
    });
    return values;
  }

  function resolvePinnedUpsellOptions(product) {
    const cartValues = cartOptionValueSet();
    const optionCount = (product.options || []).length;
    const pinned = [];
    for (let i = 0; i < optionCount; i++) {
      if (!cartValues.size) { pinned.push(null); continue; }
      const optionValues = [...new Set(product.variants.map(v => v.options[i]))];
      const matches = optionValues.filter(v => cartValues.has(String(v).trim().toLowerCase()));
      pinned.push(matches.length === 1 ? matches[0] : null);
    }
    return pinned;
  }

  function resolveMatchedUpsellVariant(selector) {
    const productJson = selector && selector.dataset.product;
    if (!productJson) return null;

    let product;
    try { product = JSON.parse(productJson); } catch (_) { return null; }
    if (!product.variants || !product.variants.length) return null;

    const pinned = resolvePinnedUpsellOptions(product);

    // Only add silently when the cart pins EVERY option to exactly one value
    if (!pinned.length || pinned.some(v => v === null)) return null;

    return product.variants.find(v =>
      v.available && v.options.every((opt, i) => opt === pinned[i])
    ) || null;
  }

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.btn.rec-add.rec-vs-open');
    if (!button) return;

    const variantId = button.dataset.id;
    if (!variantId) return;

    button.classList.add('btn--loading');

    const selector = document.querySelector(`.upsell-variant-selector[data-vsp="${variantId}"]`);

    // Cart already pins every option (e.g. Device) → add the matched variant, no dropdown
    const matched = resolveMatchedUpsellVariant(selector);
    if (matched) {
      try {
        await addToCart(matched.id);
        document.dispatchEvent(new CustomEvent('cart:build', { detail: buildDetail() }));
      } catch (error) {
        console.error('Failed to add matched variant:', error);
      } finally {
        button.classList.remove('btn--loading');
      }
      return;
    }

    setTimeout(() => {
      button.classList.remove('btn--loading');

      if (selector) {
        selector.classList.add('is-active');
        const cartDrawer = document.querySelector('#CartDrawer');
        if (cartDrawer) cartDrawer.classList.add('vs-open');
      }
    }, 200);
  });

  function closeVselector() {
    // Remove vs-open from the CartDrawer
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) cartDrawer.classList.remove('vs-open');

    // Remove active state from all variant selectors
    document.querySelectorAll('.upsell-variant-selector.is-active')
      .forEach(el => el.classList.remove('is-active'));

    // Remove loading state from any upsell buttons
    document.querySelectorAll('.btn.rec-add.btn--loading')
      .forEach(btn => btn.classList.remove('btn--loading'));
  }

  // Attach listeners to all .vs-close buttons
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.vs-close');
    if (closeBtn) closeVselector();
  });




  // ==============================
// DYNAMIC VARIANT OPTION DISABLING
// ==============================
function updateVariantOptionAvailability(selector) {
  const productJson = selector.dataset.product;
  if (!productJson) return;

  let product;
  try { product = JSON.parse(productJson); } catch (e) { return; }

  const pillGroups = selector.querySelectorAll('.product-option-pills');
  const availableVariants = product.variants.filter(v => v.available);

  // Build current selection
  const currentSelection = [];
  pillGroups.forEach(group => {
    const select = group.querySelector('select')
    currentSelection.push(select && select.value ? select.value : null)
  });

  // For each option group
  pillGroups.forEach((group, groupIndex) => {
    const options = group.querySelectorAll('option')

    options.forEach(option => {
      const value = option.value
      let isAvailable = false;

      // Test: is there ANY available variant that matches:
      // - All current selections (except this one)
      // - This value for the current option
      for (const variant of availableVariants) {
        let matches = true;

        for (let i = 0; i < product.options.length; i++) {
          if (i === groupIndex) {
            // This is the option we're testing
            if (variant.options[i] !== value) {
              matches = false;
              break;
            }
          } else {
            // Other options: must match current selection (or be null)
            const selected = currentSelection[i];
            if (selected && variant.options[i] !== selected) {
              matches = false;
              break;
            }
          }
        }

        if (matches) {
          isAvailable = true;
          break;
        }
      }

      // Update UI
      option.disabled = !isAvailable
    });
  });

  // Auto-select first available if nothing selected
  const hasAnySelection = currentSelection.some(v => v !== null);
  if (!hasAnySelection && availableVariants.length > 0) {
    const first = availableVariants[0];
    pillGroups.forEach((group, idx) => {
      const select = group.querySelector('select')
      if (select) select.value = first.options[idx]
    });
  }
}

// Recalculate availability whenever a shopper changes an upsell option
document.addEventListener('change', (e) => {
  const select = e.target
  if (!select.matches('.upsell-variant-selector .product-option-pills select')) return

  const selector = select.closest('.upsell-variant-selector')
  if (!selector) return

  updateVariantOptionAvailability(selector)
});


  /* --------------------------------------------------------------
   UPSELL PILL SELECTOR → CART (NO PRICE UPDATE)
   -------------------------------------------------------------- */

document.addEventListener('click', async (e) => {
  const confirmBtn = e.target.closest('.upsell-confirm-btn');
  if (!confirmBtn) return;

  const selector = confirmBtn.closest('.upsell-variant-selector');
  if (!selector) return;

  const productJson = selector.dataset.product;
  if (!productJson) return;

  let product;
  try { product = JSON.parse(productJson); } catch (err) {
    return console.error('JSON parse error:', err);
  }

  // COLLECT SELECTED OPTIONS
  const selectedOptions = [];
  const pillGroups = selector.querySelectorAll('.product-option-pills');

  let hasSelection = true;
  pillGroups.forEach(group => {
    const select = group.querySelector('select');
    const value = select ? select.value : null;

    if (!value) hasSelection = false;
    selectedOptions.push(value);
  });

  if (!hasSelection) {
    alert('Please select all options.');
    return;
  }

  // FIND MATCHING VARIANT
  const variant = product.variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!variant) {
    alert('Selected combination not available.');
    return;
  }

  if (!variant.available) {
    alert('This variant is sold out.');
    return;
  }

  // ADD TO CART
  confirmBtn.classList.add('btn--loading');
  confirmBtn.disabled = true;

  try {
    await addToCart(variant.id);
    closeVselector();
    document.dispatchEvent(new CustomEvent('cart:build', { detail: buildDetail() }));
  } catch (err) {
    console.error('Add failed:', err);
    alert('Could not add item.');
  } finally {
    confirmBtn.classList.remove('btn--loading');
    confirmBtn.disabled = false;
  }
});

// AUTO-SELECT FIRST AVAILABLE ON OPEN
document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('.btn.rec-add.rec-vs-open');
  if (!openBtn) return;

  setTimeout(() => {
    const selector = document.querySelector('.upsell-variant-selector.is-active');
    if (!selector) return;

    const productJson = selector.dataset.product;
    if (!productJson) return;

    let product;
    try { product = JSON.parse(productJson); } catch (_) { return; }

    const availableVariants = product.variants.filter(v => v.available);
    if (!availableVariants.length) {
      const btn = selector.querySelector('.upsell-confirm-btn');
      btn.disabled = true;
      btn.textContent = 'Sold Out';
      return;
    }

    // Preselect from the cart match where possible (e.g. Device pinned by the
    // case already in the cart), falling back to the first available variant
    const pinned = resolvePinnedUpsellOptions(product);
    const first = availableVariants[0];
    const pillGroups = selector.querySelectorAll('.product-option-pills');

    pillGroups.forEach((group, idx) => {
      const select = group.querySelector('select');
      if (!select) return;
      const value = pinned[idx] != null ? pinned[idx] : first.options[idx];
      if (value != null) select.value = value;
    });

    // Trigger dynamic update
    updateVariantOptionAvailability(selector);

    const btn = selector.querySelector('.upsell-confirm-btn');
    btn.disabled = false;
    btn.textContent = 'Confirm';
  }, 250);
});
  




  const countdownTimers = new Map()

  function initCountdown(el) {
    const existing = countdownTimers.get(el)
    if (existing) clearInterval(existing)

    const id = el.id || `countdown-${Math.random().toString(36).slice(2)}`;
    const minutes = parseInt(el.dataset.minutes, 10) || 10;
    const textTemplate = el.dataset.text || "⏳ Time left: {time}";
    const cycleSeconds = minutes * 60;

    function pad(n) { return n.toString().padStart(2, '0'); }

    // Start fresh each time (no persistence)
    let startTime = Date.now();

    function update() {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      const remainder = elapsed % cycleSeconds;
      let secondsLeft = cycleSeconds - remainder;

      // Reset automatically when it reaches zero
      if (secondsLeft <= 0 || secondsLeft > cycleSeconds) {
        startTime = Date.now();
        secondsLeft = cycleSeconds;
      }

      const m = Math.floor(secondsLeft / 60);
      const s = secondsLeft % 60;
      const formattedTime = `${pad(m)}:${pad(s)}`;

      /* the digits sit in their own element so the block's "Time digits" colour can apply (2026-09-21) */
      el.textContent = '';
      const parts = textTemplate.split('{time}');
      parts.forEach((part, i) => {
        if (part) el.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) { const b = document.createElement('b'); b.className = 'cd-time'; b.textContent = formattedTime; el.appendChild(b); }
      });
    }

    update();
    countdownTimers.set(el, setInterval(update, 1000))
  }


  function sweepCountdowns() {
    countdownTimers.forEach((intervalId, el) => {
      if (el.isConnected) return
      clearInterval(intervalId)
      countdownTimers.delete(el)
    })
  }

  document.addEventListener('shopify:section:unload', sweepCountdowns)
  document.addEventListener('shopify:section:load', (e) => {
    sweepCountdowns()
    e.target.querySelectorAll('.countdown').forEach(initCountdown)
  })

  document.querySelectorAll('.countdown').forEach(initCountdown)



});



document.addEventListener('DOMContentLoaded', function () {

  const stickyEl = document.querySelector('.sticky-atc');
  const targetEl = document.querySelector('.payment-buttons .add-to-cart');

  if (stickyEl && targetEl) {
    let lastY = window.scrollY;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const currentY = window.scrollY;
        const scrollingDown = currentY > lastY;
        lastY = currentY;

        if (!entry.isIntersecting && scrollingDown) {
          // Button went above (scrolled down past it)
          stickyEl.classList.add('sticky-shown');
        } else if (entry.isIntersecting) {
          // Button visible again — remove sticky
          stickyEl.classList.remove('sticky-shown');
        }
      });
    }, { threshold: 0 });

    observer.observe(targetEl);
  }


});

// ==============================
// SCF 2026-09-22 FREE GIFT CHOOSER (sheet inside the cart drawer: size squares / device list)
// The choice is stored as a cart attribute (_scf_gift_<product id>) so the drawer's
// server-rendered markup carries it and checkout reads the resolved variant as before.
// ==============================
(function () {
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function host() { return document.getElementById('CartDrawer') || document.body; }
  function closeSheet() { document.querySelectorAll('.scf-sheet, .scf-sheet-back').forEach(function (n) { n.remove(); }); }

  async function setGiftChoice(box, variantId) {
    var attr = box && box.dataset.giftAttr;
    if (!attr) return;
    box.classList.add('is-saving');
    try {
      var attributes = {};
      attributes[attr] = variantId ? String(variantId) : '';
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes, sections: 'cart-ajax-section' })
      });
      if (!res.ok) throw new Error('Gift choice was not saved.');
      var cart = await res.json();
      document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));
      if (typeof refreshCart === 'function') await refreshCart();
    } catch (err) {
      box.classList.remove('is-saving');
      console.error('Gift choice:', err);
    }
  }

  function groupKey(v) {
    var w = String(v).trim().split(/\s+/);
    if (w.length < 2) return w[0];
    if (/^[A-Za-z]{1,2}\d/.test(w[0])) return w[0];        // "S26 Ultra" -> "S26"
    return w[0] + ' ' + w[1];                                // "iPhone 18 Pro Max" -> "iPhone 18"
  }

  function openSheet(box) {
    var node = box.querySelector('[data-gift-data]');
    var data = null;
    try { data = node ? JSON.parse(node.textContent) : null; } catch (_) {}
    if (!data || !data.options || !data.options.length) return;
    closeSheet();
    var sel = (data.selected || []).slice();
    while (sel.length < data.options.length) sel.push('');
    var prefill = data.prefill || [];

    function avail(i, v) {
      return data.variants.some(function (x) {
        return x.available && x.options[i] === v && data.options.every(function (o, j) { return j === i || !sel[j] || x.options[j] === sel[j]; });
      });
    }
    function match() {
      if (sel.some(function (v) { return !v; })) return null;
      return data.variants.find(function (x) { return x.available && x.options.every(function (o, i) { return o === sel[i]; }); }) || null;
    }
    function row(i, v, star) {
      return '<button type="button" class="scf-sheet__row' + (sel[i] === v ? ' is-on' : '') + '" data-i="' + i + '" data-v="' + esc(v) + '"' + (avail(i, v) ? '' : ' disabled') + '><i></i>' + esc(v) + (star ? '<u>in your cart</u>' : '') + '</button>';
    }
    function listHtml(i, q) {
      q = (q || '').trim().toLowerCase();
      var vals = data.options[i].values.filter(function (v) { return !q || v.toLowerCase().indexOf(q) !== -1; });
      if (!vals.length) return '<div class="scf-sheet__none">No match</div>';
      var out = '';
      if (prefill[i] && !q && vals.indexOf(prefill[i]) !== -1) out += '<div class="scf-sheet__grp">In your cart</div>' + row(i, prefill[i], true);
      var groups = {}, order = [];
      vals.forEach(function (v) { var k = groupKey(v); if (!groups[k]) { groups[k] = []; order.push(k); } groups[k].push(v); });
      order.forEach(function (k) { out += '<div class="scf-sheet__grp">' + esc(k) + '</div>' + groups[k].map(function (v) { return row(i, v, false); }).join(''); });
      return out;
    }
    function render() {
      var h = '<div class="scf-sheet__h"><b>Free ' + esc(data.title) + '</b><button type="button" class="scf-sheet__x" aria-label="Close">✕</button></div>';
      data.options.forEach(function (opt, i) {
        h += '<div class="scf-sheet__lab">' + esc(opt.name) + '</div>';
        if (opt.values.length <= 12) {
          h += '<div class="scf-sheet__sz">' + opt.values.map(function (v) {
            return '<button type="button" class="scf-sheet__opt' + (sel[i] === v ? ' is-on' : '') + '" data-i="' + i + '" data-v="' + esc(v) + '"' + (avail(i, v) ? '' : ' disabled') + '>' + esc(v) + '</button>';
          }).join('') + '</div>';
        } else {
          h += '<input class="scf-sheet__search" type="search" autocomplete="off" placeholder="Search ' + esc(opt.name.toLowerCase()) + '…" data-i="' + i + '">';
          h += '<div class="scf-sheet__list" data-list="' + i + '">' + listHtml(i, '') + '</div>';
        }
      });
      var m = match();
      h += '<button type="button" class="scf-sheet__cta" data-add' + (m ? '' : ' disabled') + '>' + (m ? 'Add free ' + esc(data.title) + ' · ' + esc(sel.join(' · ')) : 'Choose to add') + '</button>';
      sheet.innerHTML = h;
    }
    var back = document.createElement('div'); back.className = 'scf-sheet-back';
    var sheet = document.createElement('div'); sheet.className = 'scf-sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-label', 'Free ' + data.title);
    render();
    host().appendChild(back); host().appendChild(sheet);
    back.addEventListener('click', closeSheet);
    // Re-render one tick later: the theme closes the drawer when a click's target is no longer in the page.
    sheet.addEventListener('click', function (ev) { var t = ev.target; setTimeout(function () { onSheetClick({ target: t }); }, 0); });
    function onSheetClick(e) {
      var o = e.target.closest('.scf-sheet__opt, .scf-sheet__row');
      if (o && !o.disabled) {
        sel[+o.dataset.i] = o.dataset.v;
        var keep = {};
        sheet.querySelectorAll('.scf-sheet__search').forEach(function (s) { keep[s.dataset.i] = { q: s.value, top: (sheet.querySelector('[data-list="' + s.dataset.i + '"]') || {}).scrollTop || 0 }; });
        render();
        Object.keys(keep).forEach(function (i) {
          var s = sheet.querySelector('.scf-sheet__search[data-i="' + i + '"]'), l = sheet.querySelector('[data-list="' + i + '"]');
          if (s && l) { s.value = keep[i].q; l.innerHTML = listHtml(+i, keep[i].q); l.scrollTop = keep[i].top; }
        });
        return;
      }
      if (e.target.closest('.scf-sheet__x')) { closeSheet(); return; }
      if (e.target.closest('[data-add]')) { var m = match(); if (m) { closeSheet(); setGiftChoice(box, m.id); } }
    }
    sheet.addEventListener('input', function (e) {
      var s = e.target.closest('.scf-sheet__search');
      if (!s) return;
      var l = sheet.querySelector('[data-list="' + s.dataset.i + '"]');
      if (l) l.innerHTML = listHtml(+s.dataset.i, s.value);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gift-open], [data-gift-change]');
    if (!t) return;
    e.preventDefault();
    var box = t.closest('.free-gift-box');
    if (box) openSheet(box);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  document.addEventListener('cart:build', closeSheet);
})();

/* SCF 2026-09-24: iOS Safari only re-checks lazily loaded images on scroll, so the icons inside a menu screen
   that slides into view stayed blank until the first swipe. Load a screen's icons the moment its category is
   tapped, and the top-level ones when the drawer opens. */
(function () {
  var nav = document.getElementById('NavDrawer');
  if (!nav) return;
  function eager(scope) {
    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
      if (!img.complete && img.src) { var s = img.src; img.src = ''; img.src = s; }
    });
  }
  // document capture, not #NavDrawer: mega-menu.js stops propagation at document capture for category taps
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#NavDrawer .collapsible-trigger, #NavDrawer .mobile-nav__link--button');
    if (!t) return;
    var id = t.getAttribute('aria-controls');
    var panel = id && document.getElementById(id);
    if (panel) eager(panel);
  }, true);
  var seen = false;
  new MutationObserver(function () {
    var open = nav.classList.contains('drawer--is-open') || nav.classList.contains('is-open') || nav.getAttribute('aria-hidden') === 'false';
    if (open && !seen) { seen = true; eager(nav); }
    if (!open) seen = false;
  }).observe(nav, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
})();

/* SCF 2026-09-24 (2): iOS sometimes paints nothing inside a screen that has just slid in until the user scrolls.
   After the slide ends, nudge the screen and decode its icons synchronously so the first frame is complete. */
(function () {
  var nav = document.getElementById('NavDrawer');
  if (!nav) return;
  function settle(panel) {
    panel.querySelectorAll('.menu-pic img').forEach(function (img) { img.decoding = 'sync'; });
    // hard reflow of the screen, all inside one frame so nothing flashes: iOS repaints the whole screen,
    // including tiles it skipped during the slide. The scroll position is kept.
    var st = panel.scrollTop;
    panel.style.display = 'none'; void panel.offsetHeight; panel.style.display = '';
    panel.scrollTop = st;
    panel.querySelectorAll('.menu-pic').forEach(function (el) { el.style.transform = 'translateZ(0)'; });
    requestAnimationFrame(function () {
      panel.querySelectorAll('.menu-pic').forEach(function (el) { el.style.transform = ''; });
    });
  }
  nav.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'transform') return;
    var panel = e.target;
    if (panel.classList && panel.classList.contains('mobile-nav__sublist') && panel.classList.contains('is-open')) settle(panel);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#NavDrawer .collapsible-trigger, #NavDrawer .mobile-nav__link--button');
    if (!t) return;
    var id = t.getAttribute('aria-controls'); var panel = id && document.getElementById(id);
    if (panel) { settle(panel); setTimeout(function () { settle(panel); }, 320); }
  }, true);
})();

/* SCF 2026-09-24 header (deck 117 #10): live cart count in the header bubble, and on the sticky (stuck) header
   the nav splits five and four around the centred logo — this keeps that gap centred on the page. */
(function () {
  function setCount(n) {
    document.querySelectorAll('[data-scf-cart-count]').forEach(function (el) {
      el.textContent = n;
      var b = el.closest('.cart-link__bubble'); if (b) b.classList.toggle('cart-link__bubble--visible', n > 0);
    });
  }
  function refresh() { fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count || 0); }).catch(function () {}); }
  ['ajaxProduct:added', 'cart:build', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 400); }); });
  var hdr = document.getElementById('SiteHeader'); if (!hdr) return;
  function centreGap() {
    var ul = hdr.querySelector('.text-center .site-navigation'); if (!ul) return;
    ul.style.paddingLeft = ''; ul.style.paddingRight = '';
    if (!hdr.classList.contains('site-header--stuck') || window.innerWidth < 769) return;
    var items = ul.querySelectorAll(':scope > .site-nav__item'); if (items.length < 6) return;
    var left = items[4].getBoundingClientRect().right, right = items[5].getBoundingClientRect().left;
    var delta = Math.round(window.innerWidth / 2 - (left + right) / 2);
    // padding (not transform): a transform would make the ul the containing block for the mega menus
    if (delta > 0) ul.style.paddingLeft = (2 * delta) + 'px'; else if (delta < 0) ul.style.paddingRight = (-2 * delta) + 'px';
  }
  new MutationObserver(centreGap).observe(hdr, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', centreGap); centreGap();
})();
